module.exports = __webpack_public_path__ + "img/1479689325.76757c33.jpg";